<template>
  <div class="login-form login-form--extra-space">
    <h4 class="login-title">Change your password</h4>

    <form>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group mb-2">
            <label>Current password * </label>
            <input
              type="password"
              placeholder="Current password"
              class="form-control"
              v-model="oldPassword"
              :class="{
                'is-invalid': !!inValidObject['oldPassword'],
              }"
              @keyup.enter="savePassword"
            />
            <span class="invalid-feedback">
              {{ inValidObject["oldPassword"] }}
            </span>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group mb-2">
            <label>New password * </label>
            <input
              type="password"
              placeholder="New password"
              class="form-control"
              v-model="newPassword"
              :class="{
                'is-invalid': !!inValidObject['newPassword'],
              }"
              @keyup.enter="savePassword"
            />
            <span class="invalid-feedback">
              {{ inValidObject["newPassword"] }}
            </span>
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group mb-2">
            <label>Confirm password * </label>
            <input
              type="password"
              placeholder="Confirm password"
              class="form-control"
              v-model="confirmPassword"
              :class="{
                'is-invalid': !!inValidObject['confirmPassword'],
              }"
              @keyup.enter="savePassword"
            />
            <span class="invalid-feedback">
              {{ inValidObject["confirmPassword"] }}
            </span>
          </div>
        </div>

        <div class="col-md-12">
          <div v-if="saving" class="spinner-border text-info" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <button
            v-else
            type="button"
            @click="savePassword"
            class="theme-button"
          >
            Update
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      saving: false,
      oldPassword: null,
      newPassword: null,
      confirmPassword: null,
      inValidObject: {},
    };
  },
  methods: {
    async savePassword() {
      this.inValidObject = this.checkValid(
        this.oldPassword,
        this.newPassword,
        this.confirmPassword
      );

      if (Object.keys(this.inValidObject).length) {
        return;
      }

      this.saving = true;
      try {
        let resp = await this.$http.post(`Settings/ChangePassword`, {
          OldPassword: this.oldPassword,
          NewPassword: this.newPassword,
        });
        if (resp && resp.status == 200) {
          if (resp.data.message) {
            this.$swal({
              icon:
                resp.data.status == this.$const.RESPONSE_TYPES.Success
                  ? "success"
                  : null,
              text: this.$const.MESSAGE[resp.data.message],
            });
          }
          if (resp.data.status == this.$const.RESPONSE_TYPES.Success) {
            this.oldPassword = null;
            this.newPassword = null;
            this.confirmPassword = null;
            this.$user.dispatch("logout").then(() => {
              let returnUrl = this.$router.currentRoute.fullPath;
              let query = returnUrl ? { returnUrl } : null;
              this.$router.push({ name: "Login", query });
            });
          }
        } else {
          this.$swal({
            icon: "error",
            text: this.$const.MESSAGE.UpdateError,
          });
        }
      } catch (error) {
        this.$swal({
          icon: "error",
          text: error.message,
        });
      }
      this.saving = false;
    },

    checkValid(oldPassword, newPassword, confirmPassword) {
      let inValidObject = {};

      if (!oldPassword) {
        inValidObject["oldPassword"] = "Vui lòng nhập Mật khẩu hiện tại";
      }

      if (!newPassword) {
        inValidObject["newPassword"] = "Vui lòng nhập Mật khẩu mới";
      }

      if (!confirmPassword) {
        inValidObject["confirmPassword"] = "Vui lòng nhập Xác nhận mật khẩu";
      } else if (confirmPassword != newPassword) {
        inValidObject["confirmPassword"] = "Xác nhận mật khẩu không đúng";
      }

      return inValidObject;
    },
  },
};
</script>
